import React, {Component} from 'react';

import CSSModules from 'react-css-modules'
import Helmet from 'react-helmet'
// import config from '../../config'
import {Link} from '../../components'
import Styles from './NotFound.css'

@CSSModules(Styles)
export default class NotFound extends Component {
  render() {
    return (
      <div styleName="main">
      <div styleName="notfound">
        <Helmet title='Not Found'/>
        <h1>Sorry, nothing here.</h1>
        <p><Link xstrong={true} to={'/'}>Click here to return to the home page and get started.</Link></p>
      </div>
      </div>
    )
  }
}
